import styled, { keyframes } from "styled-components"
import CustomBgImage from "../../components/custom-bg-image/custom-bg-image.component"
import Container from "@mui/material/Container"
import CustomButton from "../../components/custom-button/custom-button.component"

export const Wrapper = styled.div`
  section {
    height: 300px;
  }
`

export const Hero = styled(CustomBgImage)`
  &:before {
    ${({ shadow }) =>
      shadow
        ? 'position: absolute; z-index: 1; height: 100%; width: 100%; content: ""; background: linear-gradient(0deg, rgba(0, 0, 0, 0.56), rgba(0, 0, 0, 0.56) );'
        : ""};
  }
`

export const ContainerWrapper = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;

  h1 {
    text-align: center;
    position: relative;
    z-index: 2;
    color: #ffffff;
    font-size: 48px;
  }
`

export const Banner = styled.div`
  background-color: #ad2626;
  height: 62px;
`

export const Marquee = styled.div`
  position: relative;
  width: 100vw;
  max-width: 100%;
  height: 62px;
  overflow-x: hidden;
  display: flex;
  align-items: center;
`

const marquee = keyframes`
    from { transform: translateX(0); }
    to { transform: translateX(-50%); }
`

export const Track = styled.div`
  position: absolute;
  white-space: nowrap;
  will-change: transform;
  animation: ${marquee} 20s linear infinite;
`

export const Title = styled.span`
  font-weight: bold;
  font-size: ${({ theme }) => theme.typography.pxToRem(37)};
  line-height: 77%;
  letter-spacing: -0.02em;
  color: #ffffff;
  font-family: "Asap", sans-serif;
  ${({ theme }) => theme.breakpoints.down("sm")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(25)};
  }
`

export const TransparentTitle = styled.span`
  font-weight: bold;
  font-size: ${({ theme }) => theme.typography.pxToRem(37)};
  line-height: 77%;
  letter-spacing: -0.02em;
  color: transparent;
  -webkit-text-stroke: 2px white;
  font-family: "Asap", sans-serif;
  ${({ theme }) => theme.breakpoints.down("sm")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(25)};
    -webkit-text-stroke: 1px white;
  }
`

export const Separator = styled.div`
  width: 20px;
  height: 20px;
  background-color: white;
  border-radius: 100px;
  margin: 0 1em;
`

export const Content = styled.div`
  display: flex;
  align-items: center;
`

export const Button = styled(CustomButton)`
  z-index: 2;
  margin: 1em 0;
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    margin-right: 0.5em;
  }
`
